import * as cookies from 'js-cookie';
import { IMainLocation } from '~/types/region';
import { FlashState, IRootState } from '~/types/store/root';

export function setFlash(state: IRootState, value: FlashState) {
    state.flash = value;
}

export function setMenuShow(state: IRootState, value: boolean) {
    state.showMenu = value;
}

export function setCurrentRegion(state: IRootState, value: IMainLocation) {

    if (!value) {
        return;
    }

    if (!state.region || state.region.city.id !== value.city.id) {
        state.region = value;
    }
}

export function setUser(state: IRootState, value) {
    state.user = value;
}

export function pushInHistory(state: IRootState, value) {
    state.history.push(value);
}

export function reviveToken(state: IRootState) {
    state.token = cookies.get('_csfr');
}

export function setToken(state: IRootState, token) {
    state.token = token;
}

export function beforeNewPage(state: IRootState) {
    state.shouldCleanBreadcrumbs = true;
}

export function setLoginFormState(state: IRootState, value: boolean) {
    state.showLoginForm = value;
    state.loginFormParams = null;
}

export function showLoginForm(state: IRootState, value: any = null) {
    state.showLoginForm = true;
    state.loginFormParams = value;
}

export function setBreadcrumbs(state: IRootState, value) {
    state.breadcrumbs = value;
    state.shouldCleanBreadcrumbs = false;
}

export function loadReсentSearch(state: IRootState, query: string) {
    if (typeof localStorage === 'undefined') {
       return;
    }

    const item = localStorage.getItem('recent-search');

    if (!item) {
        return;
    }

    try {
        state.recentSearch = JSON.parse(item);
    } catch {
        localStorage.removeItem('recent-search');
    }
}

export function addReсentSearch(state: IRootState, query: string) {
    if (typeof localStorage === 'undefined') {
       return;
    }

    // если такой запрос у нас уже был в обозримом прошлом, то просто поднимаем его наверх
    if (state.recentSearch.includes(query)) {
        const idx = state.recentSearch.indexOf(query);
        state.recentSearch.splice(idx, 1);
        state.recentSearch.unshift(query);
    } else {
        state.recentSearch.unshift(query);
        state.recentSearch = state.recentSearch.slice(0, 10);
    }
 
    localStorage.setItem('recent-search', JSON.stringify(state.recentSearch));
}

export function removeReсentSearch(state: IRootState, query: string) {
    if (typeof localStorage === 'undefined') {
       return;
    }

    if (state.recentSearch.includes(query)) {
        const idx = state.recentSearch.indexOf(query);
        state.recentSearch.splice(idx, 1);
    }
 
    localStorage.setItem('recent-search', JSON.stringify(state.recentSearch));
}
